import { css } from '@emotion/core';
import { rgba, variables, tokens } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font,
  global = variables.global;
var colors = tokens.colors;
export var container = {
  name: "79elbk",
  styles: "position:relative;"
};
export var item = {
  name: "1647809",
  styles: "margin-top:18px;"
};
export var itemsContainer = {
  name: "1647809",
  styles: "margin-top:18px;"
};
export var itemIconContainer = {
  name: "18sd2v",
  styles: "display:inline-block;padding-right:10px;vertical-align:top;"
};
export var itemTextContainer = {
  name: "15pvrel",
  styles: "display:inline-block;max-width:585px;width:calc(100% - 28px);"
};
export var itemIcon = /*#__PURE__*/css("color:", colors.interactive.base.default, ";");
export var title = {
  name: "1yuhvjn",
  styles: "margin-top:16px;"
};
export var itemDescription = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";line-height:1.5;color:", colour.neutral700, ";padding:0;");
export var itemTitle = /*#__PURE__*/css(itemDescription, ";font-weight:", font.headingFontWeight, ";color:", colors.interactive.base.default, ";border:0;background:none;cursor:pointer;padding:0;outline:none;text-align:left;&:hover{color:", colors.interactive.base.hover, ";}");
export var disabledPanelOverlay = /*#__PURE__*/css("position:absolute;top:0;right:0;bottom:0;left:0;z-index:", global.layerPopout, ";background:", rgba(colour.white, 0.7), ";");
export var disabledPanelText = /*#__PURE__*/css("position:absolute;top:50%;left:50%;font-size:18px;z-index:", global.layerPopout + 1, ";transform:translate(-50%,0);font-weight:600;background:", colour.neutral500, ";padding:10px;border-radius:10px;color:", colour.white, ";min-width:80%;text-align:center;");